
export default (width = 14, height = 14, color = '#797979') => `
<svg width="${width}" height="${height}" viewBox="0 0 296.75 296.75" xmlns="http://www.w3.org/2000/svg">
    <path d="M296.75 149.188L215 98.875v33.5H0v33h215v32.5z" stroke="${color}"/>
</svg>
`